import React from "react";
import { getIcon } from "../../../../utils/images";
import "./NotificationHeader.scss";
import { Nav } from "react-bootstrap";

const NotificationHeader = ({ }) => {
  return (
    <div className="NotificationHeader">
      <div className="header">
        <img src={getIcon('bell-lg')} />
        <div className="header__title">Notifications</div>
      </div>
      <div className="content">
        <Nav className="app-tabs nav">
          <Nav.Item>
            <Nav.Link eventKey="all">
              <div>All</div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="better_price">
              <div>Better Price</div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="updates">
              <div>Updates</div>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="docs">
              <div>Docs</div>
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
    </div>
  )
}

export default NotificationHeader;
